import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import ModalInfo from '../../../../shared/components/modals/ModalInfo'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

function AdminDetailInfo({ resourceSelected }: any) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  return (
    <>
      {isMobile && (
        <Grid container justifyContent="center" spacing={4}>
          <Grid xs={12} sm={4}>
            <ModalInfo title={t('roles')} options={resourceSelected.role} />
          </Grid>
          <Grid xs={12} sm={4}>
            <ModalInfo title={t('countries')} options={resourceSelected.countries} />
          </Grid>
          <Grid xs={12} sm={4}>
            <ModalInfo title={t('language')} options={resourceSelected.languages} />
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default AdminDetailInfo
